import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { DigitalWalletBannerModule } from '../digital-wallet-banner/digital-wallet-banner.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { Is4upsBannerModule } from '../is4ups-banner/is4ups-banner.module';
import { NavigationModule } from '../navigation/navigation.module';
import { SwitchPolicyNotifyModule } from '../switch-policy-notify/switch-policy-notify.module';
import { TopNavigationModule } from '../top-navigation/top-navigation.module';
import { LayoutNoIdentityComponent } from './layout-no-identity.component';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Is4upsMultiCarrierBannerModule } from '../is4ups-multi-carrier-banner/is4ups-multi-carrier-banner.module';
@NgModule({
  declarations: [LayoutNoIdentityComponent],
  imports: [
    CommonModule,
    FooterModule,
    HeaderModule,
    NavigationModule,
    SharedModule,
    TopNavigationModule,
    DigitalWalletBannerModule,
    SwitchPolicyNotifyModule,
    Is4upsBannerModule,
    MatListModule,
    MatMenuModule,
    MatTooltipModule,
    Is4upsMultiCarrierBannerModule
  ]
})
export class LayoutNoIdentityModule { }
